/**
 * Translatable labels for domain values (ids travel via sync
 * and are not translated; see `@gymlog/shared` gym/constants).
 */

import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { EquipmentType, MuscleGroup } from "@gymlog/shared";

const MUSCLE_GROUP_LABELS: Record<MuscleGroup, MessageDescriptor> = {
  chest: msg`Chest`,
  back: msg`Back`,
  shoulders: msg`Shoulders`,
  biceps: msg`Biceps`,
  triceps: msg`Triceps`,
  forearms: msg`Forearms`,
  quads: msg`Quads`,
  hamstrings: msg`Hamstrings`,
  glutes: msg`Glutes`,
  calves: msg`Calves`,
  core: msg`Core`,
  full_body: msg`Full body`,
};

const EQUIPMENT_LABELS: Record<EquipmentType, MessageDescriptor> = {
  barbell: msg`Barbell`,
  dumbbell: msg`Dumbbell`,
  machine: msg`Machine`,
  cable: msg`Cable`,
  bodyweight: msg`Bodyweight`,
  kettlebell: msg`Kettlebell`,
  band: msg`Band`,
  other: msg`Other`,
};

const MUSCLE_LOOKUP: Record<string, MessageDescriptor> = MUSCLE_GROUP_LABELS;
const EQUIPMENT_LOOKUP: Record<string, MessageDescriptor> = EQUIPMENT_LABELS;

export function muscleGroupLabel(group: string | null | undefined): MessageDescriptor {
  return MUSCLE_LOOKUP[group ?? ""] ?? MUSCLE_GROUP_LABELS.full_body;
}

export function equipmentLabel(equipment: string | null | undefined): MessageDescriptor {
  return EQUIPMENT_LOOKUP[equipment ?? ""] ?? EQUIPMENT_LABELS.other;
}

/** Formats weight in kg without trailing zeros (87.5 → "87.5", 80 → "80"). */
export function formatKg(value: number | null | undefined): string {
  const n = typeof value === "number" && Number.isFinite(value) ? value : 0;
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
}
